<!-- Main Sidebar Container -->
<aside class="main-sidebar sidebar-dark-primary elevation-4">
  <app-sidebar-brand-logo></app-sidebar-brand-logo>
  <app-sidebar-menu></app-sidebar-menu>
</aside>
